import useTypedTranslation from '@/hooks/useTypedTranslation';
import { CommonEnum } from '@/types/translations/CommonEnum';
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'next-share';
import { ListGroup, Modal } from 'react-bootstrap';

export default function ShareModal({
  showShareModal,
  handleCloseShareModal,
  url,
  title,
}: {
  showShareModal: boolean;
  handleCloseShareModal: () => void;
  url: string;
  title: string;
}) {
  const { translate } = useTypedTranslation<CommonEnum>('common');

  return (
    <Modal show={showShareModal} onHide={handleCloseShareModal}>
      <Modal.Header closeButton>
        <Modal.Title>{translate(CommonEnum.share)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ListGroup variant="flush">
          <ListGroup.Item>
            <FacebookShareButton
              url={url}
              quote={title}
              hashtag={process.env.NEXT_PUBLIC_SITE_NAME}
            >
              <FacebookIcon size={32} round />
              <span className="ms-2">Facebook</span>
            </FacebookShareButton>
          </ListGroup.Item>
          <ListGroup.Item>
            <LinkedinShareButton url={url}>
              <LinkedinIcon size={32} round />
              <span className="ms-2">Linked In</span>
            </LinkedinShareButton>
          </ListGroup.Item>
          <ListGroup.Item>
            <WhatsappShareButton url={url} title={title} separator=":: ">
              <WhatsappIcon size={32} round />
              <span className="ms-2">Whatsapp</span>
            </WhatsappShareButton>
          </ListGroup.Item>
        </ListGroup>
      </Modal.Body>
    </Modal>
  );
}
